import { IFRAME_HEIGHT } from '@utils/ui-config'

export const switchToSeawardIFrame = () => {
    const seawardIframe = document.getElementsByClassName('seaward-iframe-container') as
            HTMLCollectionOf<HTMLElement>
    const migratedIframe = document.getElementsByClassName('iframe-container') as
            HTMLCollectionOf<HTMLElement>
    seawardIframe.item(0).style.display = 'flex'
    seawardIframe.item(0).style.height = IFRAME_HEIGHT as string
    migratedIframe.item(0).style.display = 'none'
    migratedIframe.item(0).style.height = '0vh' as string
}

export const switchToMigratedIFrame = () => {
    const seawardIframe = document.getElementsByClassName('seaward-iframe-container') as
        HTMLCollectionOf<HTMLElement>
    const migratedIframe = document.getElementsByClassName('iframe-container') as
        HTMLCollectionOf<HTMLElement>
    seawardIframe.item(0).style.display = 'none'
    seawardIframe.item(0).style.height = '0vh' as string
    migratedIframe.item(0).style.display = 'flex'
    migratedIframe.item(0).style.height = IFRAME_HEIGHT as string
}

export const hideMigratedIFrame = () => {
    const migratedIframe = document.getElementsByClassName('iframe-container') as
        HTMLCollectionOf<HTMLElement>
    const seawardIframe = document.getElementsByClassName('seaward-iframe-container') as
        HTMLCollectionOf<HTMLElement>
    migratedIframe.item(0).style.display = 'none'
    migratedIframe.item(0).style.height = '0vh' as string
    seawardIframe.item(0).style.display = 'none'
    seawardIframe.item(0).style.height = '0vh' as string
}

export const getSeawardIFrame = (): HTMLCollectionOf<HTMLElement> => {
    const seawardIframe = document.getElementsByClassName('seaward-iframe-container') as
        HTMLCollectionOf<HTMLElement>
    return seawardIframe
}
